import { useMemo } from 'react';
import { useContacts } from '~/hooks/reactQuery/queries/useContacts';
import { withContactDetails } from '~/pages/DraftsDashboard/DraftsDashboard.utils';
import { useDrafts } from '~/pages/DraftsDashboard/hooks/useDrafts';
import { useBulkRunResults } from '../../hooks/useBulkRunResults';
export function useBulkCreateResults(runId) {
    const { results, isLoading: resultsLoading, error: resultsError } = useBulkRunResults(runId, {
        refreshOnMount: true
    });
    const { drafts, isLoading: draftsLoading, error: draftsError } = useDrafts({
        refreshOnHookMount: true
    });
    const { contacts, isLoading: contactsLoading, error: contactsError } = useContacts({
        refreshOnMount: true
    });
    const createdDrafts = useMemo(()=>{
        if (!results) return [];
        const byId = new Map(withContactDetails({
            drafts,
            contacts
        }).map((draft)=>[
                draft.id,
                draft
            ]));
        return results.createdDraftIds.map((draftId)=>byId.get(draftId)).filter((draft)=>draft != null);
    }, [
        results,
        drafts,
        contacts
    ]);
    return {
        results,
        createdDrafts,
        isLoading: resultsLoading || draftsLoading || contactsLoading,
        failed: resultsError != null || draftsError != null || contactsError != null
    };
}
